// removed by extract-text-webpack-plugin
module.exports = {"container":"email-container__container__j8zp9","button":"email-container__button__zXTZ_","input":"email-container__input__2TdDh","text":"email-container__text__1iq7f"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/time-poll/panels/email-container.scss
// module id = 1768
// module chunks = 1